import { readLastSurface } from "@/shared/components/layout/module-last-surface";
import { navDestinations } from "@/shared/components/layout/nav-path";
import type { NavItem } from "@/shared/components/layout/sidebar-nav.types";

export function resolveModuleLanding({
  moduleId,
  item,
  workspaceId,
  setupFirst = false,
}: {
  moduleId: string;
  item: NavItem;
  workspaceId: string;
  setupFirst?: boolean;
}): string {
  const dests = navDestinations(item).filter((child) => child.locked !== true);
  if (dests.length === 0) {
    return navDestinations(item)[0]?.to ?? item.to;
  }
  if (setupFirst) {
    const setup = dests.find((child) => child.neverLanding === true && child.label === "Setup");
    if (setup !== undefined) return setup.to;
  }
  if (moduleId === "payroll")
    return dests.find((child) => child.neverLanding !== true)?.to ?? dests[0]?.to ?? item.to;
  const last = readLastSurface(workspaceId, moduleId);
  if (last !== null && dests.some((child) => child.to === last)) return last;
  return dests.find((child) => child.neverLanding !== true)?.to ?? dests[0]?.to ?? item.to;
}

export function sidebarHref(
  item: NavItem,
  workspaceSlug: string,
  workspaceId: string,
  setupFirst: boolean,
): string {
  if (item.children === undefined) {
    return item.to.replace("$workspaceSlug", workspaceSlug);
  }
  const landing = resolveModuleLanding({
    moduleId: item.moduleId ?? item.label,
    item,
    workspaceId,
    setupFirst: item.moduleId === "payroll" && setupFirst,
  });
  return landing.replace("$workspaceSlug", workspaceSlug);
}
